module.exports = __webpack_public_path__ + "img/2.9d174a07.png";